// extracted by mini-css-extract-plugin
export default {"container":"Sample_container__HPeEw","fieldsContainer":"Sample_fieldsContainer__p-uFv","fields":"Sample_fields__UPTna"};